import React from 'react';

const AlimentsHeader = () => {
    return (
        <div>
            <h1>Aliments</h1>
        </div>
    );
};

export default AlimentsHeader;
